export const CGU_CONTENT = {
  title: "Conditions Générales d’Utilisation",
  lastUpdated: "9 Décembre 2025",
  sections: [
    {
      title: "1. Objet",
      content: [
        "Les présentes Conditions Générales d’Utilisation (ci-après les « CGU ») ont pour objet de définir les modalités et conditions d’utilisation du service en ligne Muzo / Muzo Studio (ci-après le « Service » ou « Muzo Studio »), ainsi que les droits et obligations des utilisateurs.",
        "En accédant au Service et en créant un compte, l’utilisateur accepte sans réserve les présentes CGU."
      ]
    },
    {
      title: "2. Éditeur du Service",
      content: [
        "Le Service Muzo / Muzo Studio est édité par l'Éditeur, dont les coordonnées complètes sont disponibles dans les Mentions Légales.",
        "Email de contact : contact@muzo-studio.app",
        "(ci-après « l’Éditeur »)"
      ]
    },
    {
      title: "3. Description du Service",
      content: [
        "Muzo Studio est un service en ligne permettant à l’utilisateur :",
        "• de traiter des vidéos générées par intelligence artificielle (notamment des vidéos de type « Sora ») à partir d’un lien fourni par l’utilisateur ou d’un fichier vidéo uploadé ;",
        "• d’agrandir / upscaler ces vidéos (augmentation de la résolution via des modèles d’IA) ;",
        "• dans certains cas, de récupérer une version de la vidéo sans certains éléments de surcouche (watermarks, overlays, etc.), lorsque la source fournie par l’utilisateur le permet ;",
        "• de gérer un compte utilisateur, un dashboard, un historique de vidéos traitées ;",
        "• d’utiliser un système de crédits et/ou des abonnements pour accéder aux fonctionnalités.",
        "Important : Muzo Studio ne génère pas lui-même les vidéos d’origine : il se contente de traiter des vidéos fournies ou référencées par l’utilisateur. Muzo Studio n’est pas affilié, sponsorisé ou approuvé par OpenAI, Sora, ni par aucune autre plateforme d’IA tierce. Toute référence à ces services n’a qu’un but descriptif."
      ]
    },
    {
      title: "4. Accès au Service & Compte utilisateur",
      content: [
        "L’accès au Service nécessite :",
        "• la création d’un compte utilisateur ;",
        "• l’acceptation des présentes CGU.",
        "L’utilisateur s’engage à fournir des informations exactes lors de son inscription et à les maintenir à jour. L’accès au Service est réservé aux personnes majeures de 18 ans révolus.",
        "L’utilisateur est responsable de la confidentialité de ses identifiants (email, mot de passe) et de toute action réalisée depuis son compte. En cas de suspicion d’usage frauduleux, il doit en informer l’Éditeur dans les meilleurs délais."
      ]
    },
    {
      title: "5. Public visé",
      content: [
        "Le Service est destiné :",
        "• aux particuliers ;",
        "• aux professionnels ;",
        "• aux créateurs de contenu utilisant notamment des vidéos générées par des IA (comme Sora)."
      ]
    },
    {
      title: "6. Utilisation du Service – Vidéos & droits",
      content: [
        "L’utilisateur est seul responsable :",
        "• des liens vidéo qu’il fournit (ex : URL Sora, CDN, etc.) ;",
        "• des fichiers vidéo qu’il upload sur le Service ;",
        "• des droits qu’il détient sur ces contenus.",
        "En utilisant Muzo Studio, l’utilisateur garantit :",
        "• qu’il dispose de tous les droits, autorisations et licences nécessaires pour utiliser, traiter et modifier les vidéos qu’il envoie au Service ;",
        "• que l’utilisation du Service ne viole pas les droits d’un tiers (droit d’auteur, droit à l’image, marques, etc.) ;",
        "• que l’usage qu’il fait de vidéos avec ou sans watermark est conforme aux conditions d’utilisation et licences des plateformes d’origine (OpenAI / Sora ou autres).",
        "L’Éditeur ne retire pas activement des watermarks ni des protections techniques : il traite les vidéos telles qu’elles sont fournies par l’utilisateur (ou via les liens fournis). Si la vidéo source est dépourvue de watermark, l’Éditeur ne peut être tenu responsable de la manière dont cette source a été obtenue par l’utilisateur."
      ]
    },
    {
      title: "7. Contenus interdits",
      content: [
        "L’utilisateur s’interdit d’utiliser le Service pour traiter, héberger, télécharger, partager ou manipuler tout contenu :",
        "• illégal, contraire aux lois et réglementations en vigueur (françaises, européennes ou du pays de l’utilisateur) ;",
        "• à caractère pédopornographique ou portant atteinte aux mineurs ;",
        "• à caractère pornographique explicite ou sexuel non consenti ;",
        "• incitant à la haine, à la violence, au terrorisme, au racisme, à la xénophobie, à l’homophobie ou à toute forme de discrimination ;",
        "• comportant de la diffamation, des injures, des menaces, du harcèlement ;",
        "• portant atteinte au droit à l’image ou à la vie privée de tiers ;",
        "• constituant des deepfakes malveillants (ex : usurpation d’identité, altération trompeuse de l’image d’une personne réelle à des fins de nuisance) ;",
        "• violant des droits de propriété intellectuelle (films, séries, clips, contenus protégés, etc.) sans autorisation.",
        "En cas de doute sérieux sur le caractère légal d’un contenu, l’Éditeur se réserve le droit :",
        "• de bloquer le traitement de la vidéo concernée ;",
        "• de suspendre ou supprimer le compte de l’utilisateur ;",
        "• et, le cas échéant, d’informer les autorités compétentes."
      ]
    },
    {
      title: "8. Fonctionnement technique et limitations",
      content: [
        "L’Éditeur met en œuvre tous les moyens raisonnables pour assurer un Service de qualité, mais :",
        "• ne garantit pas un fonctionnement sans interruption, ni exempt d’erreurs ;",
        "• ne fournit aucune garantie de niveau de service (SLA) ;",
        "• ne garantit pas un résultat spécifique (qualité d’upscale, compatibilité exacte avec tous les appareils, etc.).",
        "Le traitement des vidéos nécessite l’utilisation de ressources distantes (serveurs, GPU, fournisseurs tiers comme RunPod, Firebase, etc.). À ce titre :",
        "• des temps d’attente peuvent varier selon la charge, la priorité liée à l’abonnement, ou l’affluence ;",
        "• des erreurs techniques peuvent survenir (échec de job, dépassement de ressources, indisponibilité d’un prestataire tiers).",
        "L’utilisateur reconnaît que l’accès au Service peut être temporairement interrompu pour maintenance, mises à jour ou pannes imprévues."
      ]
    },
    {
      title: "9. Conservation des vidéos & résultats",
      content: [
        "Les vidéos source et les vidéos traitées peuvent être stockées temporairement sur les serveurs et/ou services de stockage utilisés par Muzo Studio, uniquement pour permettre le traitement technique (upscale) et mettre à disposition du résultat à l’utilisateur pendant une période raisonnable.",
        "En l’état, la philosophie du Service est une conservation limitée :",
        "• les vidéos peuvent être conservées pour une durée limitée, strictement nécessaire au traitement, à l’affichage dans l’historique et au téléchargement par l’utilisateur ;",
        "• au-delà de cette durée, les vidéos peuvent être supprimées à tout moment par l’Éditeur, sans obligation de conservation ou d’archivage ;",
        "Une durée maximale de conservation pourra être précisée dans la Politique de Confidentialité. L’utilisateur est invité à télécharger et sauvegarder les vidéos qu’il souhaite conserver."
      ]
    },
    {
      title: "10. Système de crédits, abonnements et accès",
      content: [
        "L’accès à certaines fonctionnalités (ex : traitement vidéo, upscale, etc.) se fait via :",
        "• un système de crédits prépayés ;",
        "• et/ou des abonnements donnant droit à un certain volume d’utilisation.",
        "Les modalités détaillées (prix, durée, contenu exact des offres, conditions de remboursement) sont précisées dans les Conditions Générales de Vente (CGV), distinctes des présentes CGU.",
        "L’Éditeur se réserve le droit de modifier les offres, les prix et la structure des crédits et abonnements à tout moment, pour l’avenir. Les modifications ne s’appliquent pas rétroactivement aux crédits déjà achetés, sauf mention contraire explicite."
      ]
    },
    {
      title: "11. Suspension et suppression de compte",
      content: [
        "L’Éditeur se réserve le droit, à sa seule discrétion et sans préavis, de restreindre l’accès au Service, suspendre temporairement un compte ou supprimer définitivement un compte utilisateur, en cas notamment :",
        "• de non-respect des présentes CGU ;",
        "• de suspicion d’utilisation frauduleuse, abusive ou malveillante ;",
        "• d’utilisation du Service à des fins illégales ;",
        "• d’atteinte grave à l’image du Service ou de mise en cause injustifiée de l’Éditeur.",
        "Lorsque cela est possible, l’Éditeur pourra informer l’utilisateur par email avant ou après la mesure de suspension/suppression."
      ]
    },
    {
      title: "12. Propriété intellectuelle",
      content: [
        "L’ensemble des éléments composant le Service et le site Muzo Studio (charte graphique, logo, design, textes, code source, fonctionnalités, etc.) est protégé par le droit de la propriété intellectuelle et demeure la propriété exclusive de l’Éditeur, sauf mention contraire.",
        "Il est strictement interdit de copier, reproduire, distribuer, vendre, publier, exploiter de quelque manière que ce soit tout ou partie du Service ou de son contenu, sans autorisation écrite préalable de l’Éditeur, ou de tenter de désassembler, décompiler ou rétro-concevoir le Service.",
        "L’utilisateur demeure propriétaire des vidéos qu’il fournit au Service, ainsi que des résultats générés à partir de ses vidéos, sous réserve des droits éventuellement attachés aux contenus d’origine (plateformes IA, licences, etc.)."
      ]
    },
    {
      title: "13. Données personnelles",
      content: [
        "Dans le cadre de l’utilisation du Service, l’Éditeur est amené à collecter et traiter certaines données personnelles (email, logs techniques, données de connexion, etc.).",
        "Les modalités de collecte, de traitement, de conservation et les droits de l’utilisateur au titre du RGPD (droit d’accès, de rectification, de suppression, etc.) sont détaillés dans la Politique de Confidentialité du Service, accessible depuis le site."
      ]
    },
    {
      title: "14. Responsabilité",
      content: [
        "L’utilisation du Service se fait sous la seule responsabilité de l’utilisateur.",
        "L’Éditeur ne saurait être tenu responsable :",
        "• de l’utilisation des vidéos source par l’utilisateur, ni de la manière dont il a obtenu ces vidéos ;",
        "• de la violation éventuelle par l’utilisateur des conditions d’utilisation de services tiers (ex : OpenAI / Sora ou autres) ;",
        "• de toute atteinte aux droits de tiers résultant de l’utilisation du Service par l’utilisateur ;",
        "• des dommages indirects (perte de données, perte de clients, perte d’image, manque à gagner, etc.) ;",
        "• des dysfonctionnements, interruptions, ou indisponibilités du Service résultant de prestataires tiers, de pannes réseau ou d’incidents techniques.",
        "En tout état de cause, sauf disposition légale impérative contraire, la responsabilité totale de l’Éditeur, tous préjudices confondus, est limitée au montant total payé par l’utilisateur au cours des 6 derniers mois au titre de l’utilisation du Service."
      ]
    },
    {
      title: "15. Modifications des CGU",
      content: [
        "L’Éditeur se réserve le droit de modifier à tout moment les présentes CGU. En cas de modification substantielle, l’utilisateur pourra être informé par tout moyen approprié (bannière, notification sur le compte, email…).",
        "La poursuite de l’utilisation du Service après modification vaut acceptation des nouvelles CGU. Si l’utilisateur n’accepte pas les nouvelles CGU, il doit cesser d’utiliser le Service et peut demander la suppression de son compte."
      ]
    },
    {
      title: "16. Loi applicable et juridiction compétente",
      content: [
        "Les présentes CGU sont soumises au droit français.",
        "En cas de litige relatif à la validité, l’interprétation ou l’exécution des présentes CGU, et à défaut de résolution amiable, les tribunaux français seront seuls compétents.",
        "Lorsque l’utilisateur a la qualité de consommateur résidant dans l’Union européenne, il bénéficie également des règles de protection impératives applicables dans son pays de résidence, conformément au droit de l’UE."
      ]
    }
  ]
};
